import { cva, VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import React, { SVGProps } from "react";

/**
 * Icon Component
 *
 * Dynamically renders SVG icons with consistent styling and color variants.
 * Supports both imported React components and string-based SVG file paths.
 */
const iconVariants = cva("inline-block", {
  variants: {
    color: {
      primary: "",
      secondary: "text-fill-secondary-normal",
      gray: "text-fill-gray-normal",
      blue: "text-fill-blue-normal",
      red: "text-fill-red-normal",
      white: "text-fill-base-white",
    },
    // size: {
    //   sm: "size-4",
    //   md: "size-5",
    //   lg: "size-6",
    // }
  },
  defaultVariants: {
    color: "primary",
  },
});

interface IconProps
  extends Omit<SVGProps<SVGSVGElement>, "color">,
    VariantProps<typeof iconVariants> {
  icon: React.FC<SVGProps<SVGSVGElement>> | string;
  stroke?: string;
}

const Icon: React.FC<IconProps> = ({ icon, color, className, ...props }) => {
  let SvgIcon: React.FC<SVGProps<SVGSVGElement>>;

  if (typeof icon === "string") {
    try {
      // Dynamically import SVG from the icons directory when provided as a string
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      SvgIcon = require(`@/assets/icons/${icon}.svg`).default;
    } catch (_error) {
      console.error(_error);
      console.error(`🚨 Icon not found: ${icon}`);
      return null;
    }
  } else {
    SvgIcon = icon;
  }
  // Apply color variants and custom className to the SVG icon
  return (
    <SvgIcon className={cn(iconVariants({ color }), className)} {...props} />
  );
};

export { Icon };
